import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import TaxGroupForm from "./TaxRatesForms";

const TaxGroupAdd = () => {
    return (
        <Fragment>
            <TaxGroupForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default TaxGroupAdd;